import Accordion from '../../../../shared/Accordion';

const Academic = ({
  open,
  onToggle,
  editable,
  formDataEstudiante,
  handleChange,
}) => {
  return (
    <Accordion
      id="info-academica"
      title="Información académica"
      open={open}
      onToggle={onToggle}
      edit={editable}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            ¿Cuál es tu nivel de estudios?<span className="text-red-700"> *</span>
          </label>
          <select
            name="studyLevel"
            value={formDataEstudiante.studyLevel}
            onChange={handleChange}
            disabled={!editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          >
            <option value="">Selecciona una opción</option>
            <option value="Pregrado">Pregrado</option>
            <option value="Posgrado">Posgrado</option>
          </select>
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            ¿Qué carrera estás estudiando?<span className="text-red-700"> *</span>
          </label>
          <input
            type="text"
            name="career"
            value={formDataEstudiante.career}
            onChange={handleChange}
            disabled={!editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            ¿En qué Universidad estudias?<span className="text-red-700"> *</span>
          </label>
          <input
            type="text"
            name="university"
            value={formDataEstudiante.university}
            onChange={handleChange}
            disabled={!editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            ¿En qué Semestre te encuentras?<span className="text-red-700"> *</span>
          </label>
          <select
            name="semester"
            value={formDataEstudiante.semester}
            onChange={handleChange}
            disabled={!editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          >
            <option value="">Selecciona un semestre</option>
            {[...Array(10).keys()].map((i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>
      </div>
    </Accordion>
  );
};

export default Academic;
